import { Component, Input } from '@angular/core';
import { SharedModule } from '@shared/modules/shared.module';

export type IconStatusType = 'signed' | 'pending-send' | 'pending-sign' | 'pending-creation' | 'success' | 'error';

@Component({
	selector: 'app-icon-status',
	imports: [SharedModule],
	templateUrl: './icon-status.component.html',
	styleUrl: './icon-status.component.scss',
})
export class IconStatusComponent {
	@Input() status: IconStatusType = 'pending-sign';
	@Input() label = '';
	@Input() iconRight = false;

	private readonly defaultLabels: Record<IconStatusType, string> = {
		signed: 'Firmado',
		'pending-send': 'Pendiente enviar',
		'pending-sign': 'Pendiente firma',
		'pending-creation': 'Pendiente creación',
		success: 'Subido correctamente',
		error: 'Archivo con error',
	};

	// Mapping of statuses to Lucide icons
	private readonly iconMap: Record<IconStatusType, string> = {
		signed: 'CircleCheck',
		'pending-send': 'CircleArrowRight',
		'pending-sign': 'AlertCircle',
		'pending-creation': 'Clock3',
		success: 'CircleCheck',
		error: 'CircleX',
	};

	get displayLabel(): string {
		return this.label || this.defaultLabels[this.status];
	}

	get iconName(): string {
		return this.iconMap[this.status];
	}
}
